<template>
    <div class="card">
        <img v-bind:src="src" class="card-img-top" alt="">
        <div class="card-body">
            <circle-button v-on:click="openLink" class="card-button">
                <icon-arrow color="#fff"></icon-arrow>
            </circle-button>
            <h5 class="card-title">{{title}}</h5>
            <p class="card-text">
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>
    import CircleButton from "./CircleButton";
    import IconArrow from "./icons/IconArrow";

    export default {
        name: "CardContainer",

        components: {
            IconArrow,
            CircleButton
        },

        props: {
            src: String,
            title: String,
            route: String
        },

        methods: {
            openLink() {
                this.$router.push(this.route);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        @include shadow;

        max-width: 248px;
        margin: 30px auto;
        border: none;
    }

    .card-title {
        border-bottom: 1px solid $primary;
        padding-bottom: 12px;
        line-height: 1;
        font-size: 16px;
    }

    .card-body {
        position: relative;
    }

    .card-button {
        position: absolute;
        top: -16px;
        right: 20px;
    }
</style>